import { usePageTitle } from './hooks/usePageTitle';

function ContactInfo() {
  usePageTitle('Contact Info')
  return (
    <main
      id="main-content"
      className="relative overflow-hidden pt-24 pb-12 px-4 bg-gray-200"
    >
      <span style={{ position: 'relative', zIndex: 1 }}></span>

      <div className="max-w-7xl mx-auto" style={{ position: 'relative', zIndex: 1 }}>
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-blue-800 text-center mb-8">
            Contact Departments
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="category-card bg-white p-8 rounded-lg shadow-lg">
              <div className="flex flex-col items-center text-center">
                <svg
                  className="w-12 h-12 text-blue-800 mb-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 8l7.89 5.26a1 1 0 001.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <h3 className="text-xl font-bold text-blue-800 mb-4">Contact Sales</h3>
                <p className="text-gray-600 mb-2">
                  For inquiries about our products and pricing, reach out to our sales team.
                </p>
                <p className="text-blue-800 font-semibold">
                  Email:{' '}
                  <a href="mailto:sales@terrasciences.com" className="hover:underline">
                    sales@terrasciences.com
                  </a>
                </p>
              </div>
            </div>

            <div className="category-card bg-white p-8 rounded-lg shadow-lg">
              <div className="flex flex-col items-center text-center">
                <svg
                  className="w-12 h-12 text-blue-800 mb-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4m0 0v4m0-4h4m-4 0H8"
                  />
                </svg>
                <h3 className="text-xl font-bold text-blue-800 mb-4">
                  Contact Technical Support
                </h3>
                <p className="text-gray-600 mb-2">
                  Need help or troubleshooting? Our technical support team is here to assist you.
                </p>
                <p className="text-blue-800 font-semibold">
                  Email:{' '}
                  <a href="mailto:support@terrasciences.com" className="hover:underline">
                    support@terrasciences.com
                  </a>
                </p>
              </div>
            </div>

            <div className="category-card bg-white p-8 rounded-lg shadow-lg">
              <div className="flex flex-col items-center text-center">
                <svg
                  className="w-12 h-12 text-blue-800 mb-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                  />
                </svg>
                <h3 className="text-xl font-bold text-blue-800 mb-4">
                  Contact R&D Department
                </h3>
                <p className="text-gray-600 mb-2">
                  For technical collaborations and development inquiries, connect with our R&D team.
                </p>
                <p className="text-blue-800 font-semibold">
                  Email:{' '}
                  <a href="mailto:r%26d@terrasciences.com" className="hover:underline">
                    partnership@terrasciences.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="mt-24 mb-24">
          <h2 className="text-3xl font-bold text-blue-800 text-center mb-8">
            Our Offices
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="office bg-gray-50 p-4 rounded-lg shadow">
              <h3 className="text-xl font-semibold text-blue-800 mb-2 text-center">
                USA (Houston)
              </h3>
              <div className="w-full h-96">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3463.5440725431076!2d-95.46509932445703!3d29.76190557506706!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c14ec81ff243%3A0xe35974cf9e4173b9!2sTwo%20Riverway%20Holdings%20LLC!5e0!3m2!1sen!2suk!4v1740662028790!5m2!1sen!2suk"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <p className="text-center text-sm mt-2">
                Two Riverway 15th Floor, Houston, Texas, 77056 USA
              </p>
            </div>

            <div className="office bg-gray-50 p-4 rounded-lg shadow">
              <h3 className="text-xl font-semibold text-blue-800 mb-2 text-center">
                UK (Lincolnshire)
              </h3>
              <div className="w-full h-96">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2390.295793609611!2d-0.02535592301996224!3d53.19461118606561!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487877bff5dc9abf%3A0xaf55dfef18a947a5!2sBadley%20Ashton%20%26%20Associates%20Ltd!5e0!3m2!1sen!2suk!4v1739906999961!5m2!1sen!2suk"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <p className="text-center text-sm mt-2">
                Winceby House, Winceby, Horncastle, Lincolnshire, LN9 6PB UK
              </p>
            </div>

            <div className="office bg-gray-50 p-4 rounded-lg shadow">
              <h3 className="text-xl font-semibold text-blue-800 mb-2 text-center">
                UAE (Abu Dhabi)
              </h3>
              <div className="w-full h-96">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7261.873451155767!2d54.35830904508218!3d24.487649126507822!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e66668fc466ab%3A0xf2091eeb67e09527!2sAYA%20Business%20Centre%20-%20Main%20Branch!5e0!3m2!1sen!2suk!4v1739907546719!5m2!1sen!2suk"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>
              <p className="text-center text-sm mt-2">
                Office 849 | Floor 8 | Al Ghaith Tower, Hamdan Street, Abu Dhabi - UAE
              </p>
            </div>

          </div>
        </section>
      </div>

      <span style={{ position: 'relative', zIndex: 1 }}></span>
    </main>
  );
}

export default ContactInfo;
